<template>
  <!--언어 선택-->
  <div class="contents-wrap">
    <button
      class="button-dim button-full-width button-small"
      ref="triggerLanRef"
      :disabled="disabled"
      @click="toggleDropdown"
    >
      <div class="label-wrap">
        <Tag
          v-if="microphone.customLabel?.trim()"
          :label="microphone.customLabel"
          type="gray-light"
          class="mic-tag"
        />
        <p class="truncate">{{ microphone.label || '마이크 선택' }}</p>
      </div>
      <component
        class="icon-medium"
        :is="showDropdown ? ChevronUpIcon : ChevronDownIcon"
      />
    </button>

    <Dropdown
      v-if="showDropdown"
      position="below"
      :trigger-ref="triggerLanRef"
      :class="{ active: showDropdown }"
      @close="toggleDropdown"
    >
      <MicList @select="selectMic" />
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { cloneDeep } from 'lodash';

import ChevronDownIcon from '@/components/icons/IconChevronDown.vue';
import ChevronUpIcon from '@/components/icons/IconChevronUp.vue';
import Dropdown from '@/components/shared/base/Dropdown.vue';
import { IMicrophone } from '@/types/components';

import MicList from './MicList.vue';
import Tag from '../base/Tag.vue';

const microphone = defineModel<
  Pick<IMicrophone, 'id' | 'label' | 'customLabel'>
>({
  required: true,
  default: () => ({}),
});

withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  }
);

const showDropdown = ref<boolean>(false);
const triggerLanRef = ref();

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const selectMic = (mic: Pick<IMicrophone, 'id' | 'label' | 'customLabel'>) => {
  if (mic) {
    microphone.value = cloneDeep(mic);
  }
  toggleDropdown();
};
</script>

<style scoped lang="scss">
.contents-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 3rem;
  gap: 0.25rem;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.label-wrap {
  display: flex;
  width: 100%;
  min-width: 0;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
}

.mic-label {
  font-size: 0.875rem;
  color: var(--text-dim);
  background-color: var(--surface-hover);
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  max-width: 6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
